export const CompanyInfo = {
  Copyright: '© 2019 woorihero Inc',
};
